
import { defineComponent } from 'vue';
import '../assets/brandie.css';

export default defineComponent({
  name: 'Curriculum',
  data() {
    return {
      techLinks: [
        {
          url: 'https://reactjs.org',
          title: 'ReactJS',
          icon: 'fab fa-react',
        }, {
          url: 'https://v3.vuejs.org',
          title: 'VueJS',
          icon: 'fab fa-vuejs',
        }, {
          url: 'https://nodejs.org',
          title: 'NodeJS',
          icon: 'fab fa-node-js',
        }, {
          url: 'https://www.gatsbyjs.com/',
          title: 'Gatsby',
          icon: 'icon-gatsby',
        }, {
          url: 'https://shopify.dev',
          title: 'Shopify',
          icon: 'fab fa-shopify',
        }, {
          url: 'https://graphql.org/',
          title: 'GraphQL',
          icon: 'icon-graphql',
        },
      ],
      toolsLinks: [
        {
          url: 'https://code.visualstudio.com',
          title: 'Code',
          icon: 'icon-vscode',
        }, {
          url: 'https://git-scm.com',
          title: 'Git',
          icon: 'fab fa-git-alt',
        }, {
          url: 'https://firebase.google.com/',
          title: 'Firebase',
          icon: 'icon-firebase',
        }, {
          url: 'https://aws.amazon.com/',
          title: 'AWS',
          icon: 'fab fa-aws',
        }, {
          url: 'https://www.sketch.com/',
          title: 'Sketch',
          icon: 'fab fa-sketch',
        }, {
          url: 'https://www.adobe.com/products/photoshop.html',
          title: 'Photoshop',
          icon: 'icon-photoshop',
        }, {
          url: 'https://docs.docker.com/compose/',
          title: 'Docker Compose',
          icon: 'fab fa-docker',
        },
      ],
    };
  },
  computed: {
    total() {
      return {
        start: new Date().getFullYear() - 2007,
        front: new Date().getFullYear() - 2013
      };
    }
  },
});
